<template>
  <span>
    <!-- <img @click="goToHome()" id="top_quit_btn" src="./../assets/images/Asset 3.png" alt=""> -->

    <!-- <span v-show="$store.getters['app/overlays'].show_game_overlay">
      <img id="gezond_lichaam_img_2" src="./../assets/images/Asset 2.png" alt="">
      <img id="person_img_2" src="./../assets/images/Asset 1.png" alt="">

      <div class="game_container">
        <div>
          <img class="klontje" id="klontje_first" src="./../assets/images/Asset 21.png" alt="">
          <img class="klontje" src="./../assets/images/Asset 22.png" alt="">
          <img class="klontje" src="./../assets/images/Asset 23.png" alt="">
          <img class="klontje" src="./../assets/images/Asset 24.png" alt="">
          <img class="klontje" src="./../assets/images/Asset 25.png" alt="">
        </div>
        <div>
          <img id="product_first" src="./../assets/images/Asset 20_2.png" alt="">
          <img class="product" src="./../assets/images/Asset 11.png" alt="">
          <img class="product" src="./../assets/images/Asset 9.png" alt="">
          <img class="product" src="./../assets/images/Asset 10.png" alt="">
          <img class="product" src="./../assets/images/Asset 19.png" alt="">
        </div>

        <div>
          <span class="bar" id="bar_first"></span>
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </div>

        <span id="text_bar_1">1 gram suiker</span>
        <span id="text_bar_2">1 gram suiker</span>
        <span id="text_bar_3">1 gram suiker</span>
        <span id="text_bar_4">1 gram suiker</span>
        <span id="text_bar_5">1 gram suiker</span>
      </div>
    </span> -->
  </span>
</template>

<script>


export default {
  name: "Start",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },
  },

  computed: {}
};
</script>

<style>
  @font-face {
    font-family: "LuckiestGuy";
    src: url('./../assets/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  }

  #text_title {
    font-family: 'LuckiestGuy';
    position: fixed;
    margin-top: 23px;
    left: 255px;
    color: #69a643;
    z-index: 1;
    font-size: 4.5em;
  }

  #top_quit_btn {
    cursor: url('./../assets/cursor/material-wood-pointer.png'), default;	
    position: fixed;
    margin-top: 48px;
    right: 63px;
  }
  #top_quit_btn:hover {
    opacity: 0.7;
  }

  #gezond_lichaam_img_2 {
    position: fixed;
    top: 27px;
    left: 269px;
    width: auto;
    height: 300px;
  }

  #person_img_2 {
    position: fixed;
    top: 242px;
    right: 430px;
    width: auto;
    height: 623px;
  }

  .game_container {
    width: 952px;
    height: 526px;
    position: fixed;
    background-color: #fcce07;
    left: 72px;
    top: 350px;
    border-radius: 35px;
    border-style: solid;
    border-color: #fefefe;
    border-width: 10px;
  }

  #klontje_first {
    margin-left: 100px;
    margin-top: 10px;
  }

  #product_first {
    margin-left: 100px;
    margin-right: 10px;
    margin-top: 10px;
  }

  .product {
    margin-top: 10px;
    margin-left: 40px;
  }

  .bar {
    width: 100px;
    height: 40px;
    background-color: white;
    z-index: 1;
    border-radius: 30px;
    box-shadow: 5px 5px 8px 0px grey;
    display: inline-block;
    margin-left: 60px;
    margin-top: 20px;
  }

  #bar_first {
    margin-left: 90px;
  }

  #text_bar_1 {
    font-family: 'LuckiestGuy';
    position: fixed;
    margin-top: 20px;
    left: 177px;
    color: #69a643;
    z-index: 1;
    font-size: .8em;
  }

  #text_bar_2 {
    font-family: 'LuckiestGuy';
    position: fixed;
    margin-top: 20px;
    left: 340px;
    color: #69a643;
    z-index: 1;
    font-size: .8em;
  }

  #text_bar_3 {
    font-family: 'LuckiestGuy';
    position: fixed;
    margin-top: 20px;
    left: 500px;
    color: #69a643;
    z-index: 1;
    font-size: .8em;
  }

  #text_bar_4 {
    font-family: 'LuckiestGuy';
    position: fixed;
    margin-top: 20px;
    left: 660px;
    color: #69a643;
    z-index: 1;
    font-size: .8em;
  }

  #text_bar_5 {
    font-family: 'LuckiestGuy';
    position: fixed;
    margin-top: 20px;
    left: 820px;
    color: #69a643;
    z-index: 1;
    font-size: .8em;
  }
</style>


